import React, {
  FunctionComponent,
  useEffect,
  useReducer,
  useState
} from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { TableComponent } from "../../components/Table";
import { deleteDiseaseById, getDiseaseList } from "../../services";
import { Disease } from "../../types/api";

export const DiseaseDashboard: FunctionComponent = () => {
  const [diseases, updateDiseases] = useState<Array<Disease|null>>([]);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const dispatch = useDispatch();
  useEffect(() => {
    getDiseaseList({ dispatch, updateDiseases });
  }, [dispatch]);

  const navigate = useNavigate();
  const colDisplay = ["name", "type", "image_url"];
  const editFunc = (id: string | undefined) => {
    navigate(`/disease/${id}`);
  };
  const deleteFunc = async (id: string | undefined, index: number) => {
    deleteDiseaseById({
      dispatch,
      updateDiseases,
      id,
      index,
      forceUpdate
    });
  };
  const createFunc = () => {
    navigate("/disease/create");
  };

  return (
    <TableComponent
      dataInput={diseases}
      colDisplay={colDisplay}
      createFunc={createFunc}
      editFunc={editFunc}
      deleteFunc={deleteFunc}
    />
  );
};
